// extracted by mini-css-extract-plugin
module.exports = {"mainClassName":"linkToProfile_mainClassName__2wbsH"};